export const production = {
  env: 'prod',
  baseUrl: process.env['REACT_APP_BASE_URL'],
  // baseUrl: 'http://localhost:82',
  // baseUrl: 'https://zaidint.ng',
  version: 1,
};
